type ResolveAuthoritativeAccessLevelInput = {
  cachedAccessLevel: number;
  loadAccessLevel: () => Promise<number>;
};

export async function resolveAuthoritativeAccessLevel({
  loadAccessLevel,
}: ResolveAuthoritativeAccessLevelInput): Promise<number> {
  try {
    const accessLevel = await loadAccessLevel();
    return Number.isFinite(accessLevel) ? accessLevel : 0;
  } catch {
    return 0;
  }
}
